import { useQuery } from 'react-query';
import { useContext } from 'react';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { AppContext } from 'views/App/context';

import type { AccreditationVersion } from '../../../_types/awb';

export async function getAccreditationVersion(
  orgId: string,
  accreditationBodyId: string,
  id: string,
  useRUIData = false
): Promise<AccreditationVersion> {
  // Use non-org-specific API when awbRUIData feature is enabled
  const url = useRUIData
    ? `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationBodyId}/versions/${id}`
    : `${baseApiUrl()}/awb/accreditation-body/v2/organizations/${orgId}/accreditation-bodies/${accreditationBodyId}/versions/${id}`;

  const data = await fetcher({
    method: 'get',
    url,
  });
  return data;
}

export default function useAccreditationVersion(
  orgId: string,
  accreditationBodyId: string,
  id?: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const { isFeatureEnabled } = useContext(AppContext);
  const useRUIData = isFeatureEnabled('awbRUIData') || isFeatureEnabled('awbPremiumDemo');

  return useQuery<AccreditationVersion, Error>(
    ['accreditation_version', orgId, accreditationBodyId, id, useRUIData],
    () => getAccreditationVersion(orgId, accreditationBodyId, id!, useRUIData),
    {
      ...options,
      enabled: !!id,
    }
  );
}
